module.exports = __webpack_public_path__ + "static/fonts/Campton-Bold.1a5370b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Campton-Bold.eot
// module id = LvpE
// module chunks = 1